import store from 'dashboard/store';

import Patient from '../../../../templates/layout/Patient';
import overview from './overview';
import record from './record';
import dss from './dss';
import encounter from './encounter';
import expertTool from './expert-tool';

/**
 * Patient routes
 * @name router.Patient
 */

export default {
  path: 'patient/:patientId',
  component: Patient,
  meta: {
    title: t => t('people.patient'),
    loggedInOnly: true
  },
  children: [
    overview,
    record,
    dss,
    encounter,
    expertTool,
  ],
  async beforeEnter(to, from, next) {
    const { patientId } = to.params;

    if (!patientId) next({ name: 'Alerts' });

    await Promise.all([
      store.dispatch('patientSummary/get', patientId),
      // store.dispatch('alerts/getRecent', patientId),
      store.dispatch('enabledModules/getEnabledModules'),
    ]);

    if (store.getters['patientSummary/id']) next();
  },
};
